var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkeletonXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 288 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 287,
    height: 659,
    rx: 9.5,
    fill: "white",
    stroke: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 100,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 122,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 168,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 190,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 236,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 258,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 304,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 326,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 372,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 394,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 440,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 462,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 508,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 576,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 530,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 598,
    width: 256,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonXs);
export default __webpack_public_path__ + "static/media/skeleton_xs.9f1fdee2c763a5062763e170835da19b.svg";
export { ForwardRef as ReactComponent };